/* eslint-disable jsx-a11y/anchor-is-valid */
import {selectReports} from "../../../redux/slices/reports-slice";
import {useSelector} from "react-redux";

const DashboardWrapper = () => {

    const report = useSelector(selectReports)

    return (
        <div>
            {!report?.results ?
                <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center text-center">
                    <h1>
                        اطلاعات مورد نظر یافت نشد.
                    </h1>
                </div>
                :
                <div>
                <div className="table-responsive m-10 rounded">
                    <table className="table bg-secondary table-striped table-row-gray-900 gs-7 gy-7 text-center align-items-center justify-content-center">
                        <thead >
                        <tr className="fw-bolder fs-6 text-gray-800 border-bottom-2 align-items-center justify-content-center">
                            <th className="row-hidden-tb">شماره</th>
                            <th className="row-hidden-tb">تاریخ پذیرش</th>
                            <th>آزمایش</th>
                            <th>دانلود</th>
                        </tr>
                        </thead>
                        <tbody>
                        {report.results.map((item: any, index: any) => {
                            return (
                                <tr className="align-items-center justify-content-center text-center overflow-auto">
                                    <td className="row-hidden-tb">{item.number}</td>
                                    <td className="row-hidden-tb">{item.addDate}</td>
                                    <td className="">{item.test}</td>
                                    <td className="minw-100">{<a download="foo.txt" target="_blank" href={item.link}>دریافت جواب</a>}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
                </div>}
        </div>)
}

export default DashboardWrapper
